import calendar from '../../public/images/calendar.png';
import { createGlobalStyle } from 'styled-components';
import device from './devices';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/fonts/Manrope-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('/fonts/Manrope-Medium.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('/fonts/Manrope-SemiBold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/fonts/Manrope-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('/fonts/Manrope-ExtraBold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('/fonts/Manrope-Light.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url('/fonts/Manrope-ExtraLight.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope-Medium';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('/fonts/Manrope-Medium.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope-Semibold';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('/fonts/Manrope-SemiBold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Manrope-Bold';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/fonts/Manrope-Bold.ttf') format('truetype');
  }
  
  :root {
    --processes-map-table-gap: 1.5rem;
    --processes-map-side-col-width: 120px;
    --box-border-color:#ddd;
    --error-color:#ec1e1e;
  }
  html {
    font-size: 14px;
  }
  *, *:after, *:before {
    box-sizing: border-box;
  }
  
  body {
    margin: 0;
    background-color: #f3f5f9;
  }
 
  h1, h2 {
    font-family: Manrope-Semibold, sans-serif;
    font-size: 1.4rem;
    color: #2e2925;
    margin: 12px 0;
  }

  h2 { font-size: 1.2rem; }
  h3 { font-size: 1rem; }
  h4 { font-size: 0.8rem; }
  h5 { font-size: 0.7rem; }
  h6 { font-size: 0.6rem; }
  img {
    max-width:100%;
  }
  label {
    color: #545d6a;
    font-family: Manrope-Medium, sans-serif;
    font-size: var(--frk-text-base);
    margin: 24px 0 8px;
  }

  input {
    padding: var(--frk-space-1) var(--frk-space-2);
    font-size: 1rem;
    border: 1px solid #545d6a;
  }

  button {
    cursor: pointer;
    outline: none;
  }

  p {
    font-family: Manrope-Semibold, sans-serif;
    font-size: 0.875rem;
    margin: 0;
    &.gray {
      color: #545d6a;
    }
  }

  a {
    font-family: Manrope-Bold, sans-serif;
    font-size: 0.8745rem;
    color: #2e2925;
    text-decoration: inherit;
    cursor: pointer;
    &:hover, &:active, &:focus {
      text-decoration:none;
    }
  }
  b { font-family: 'Manrope-Bold', sans-serif; }
  .font-medium {
    font-family: Manrope-Medium, sans-serif;
  }
  .text-center {
    text-align:center;
  }
  
  /* //BREADCRUMBS */
  .breadcrumbs {
    margin-top: 1.5rem;
    margin-bottom: 3rem;
  }
  .breadcrumbs__inner {
    color: #aaa;
  }
  .breadcrumbs__crumb:hover {
    text-decoration: none;
    color:#333;
  }
  .breadcrumbs__crumb:focus {
    text-decoration: none;
    color:#333;
  }
  
  .breadcrumbs__crumb, .breadcrumbs__separator {
    color: #aaa;
    //margin-right: .5rem;
  }
  .breadcrumbs__separator {

    margin-right: .5rem;
    /* //separator sign hack      */
    display: inline-block;
    visibility: hidden;
    :after {
      content:'›';
      font-family: Arial;
      font-size: 1rem;
      visibility: visible;
    }
  }
  
  [type="date"] {
    padding: 14px 10px;
    font-size: 0.875rem;
    border: 1px solid #545d6a;
    background: #fff url(${calendar}) 94% 50% no-repeat;
    color: #2e2925;
    
    &:focus {
      border-color: var(--frk-color-ui-primary);
      outline: none;
    }
    
    &::-webkit-inner-spin-button {
      display: none;
    }
    
    &::-webkit-calendar-picker-indicator {
      opacity: 0;
      padding: 5px;
    }
  }
  .margin-top-05 {
    margin-top:.5rem;
  }
  .margin-top-1 {
    margin-top:1rem;
  }
  .margin-top-2 {
    margin-top:2rem;
  }
  .margin-top-3 {
    margin-top:3rem;
  }
  .margin-bottom-05 {
    margin-bottom:.5rem;
  }
  .margin-bottom-1 {
    margin-bottom:1rem;
  }
  .margin-bottom-2 {
    margin-bottom:2rem;
  }
  .margin-bottom-3 {
    margin-bottom:3rem;
  }
  .margin-left-1 {
    margin-left:1rem;
  }

  .show-for-small {
    @media ${device.tablet} {
      display: none !important;
    }
  }
  .hide-for-small {
    @media ${device.lessTablet} {
      display: none !important;
    }
  }
`;
